import React, { useEffect, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { Music } from "lucide-react";

export default function AnthemSection() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s || !s.anthem_url) return null;
  const url = imgUrl(s.anthem_url);
  const isVideo = s.anthem_type === "video";

  return (
    <section className="max-w-5xl mx-auto px-6 lg:px-10 py-16" data-testid="anthem-section">
      <div className="bg-[#1F4D2E] text-white p-8 md:p-12 rounded-sm">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#E0A526] mb-3 flex items-center gap-2"><Music size={14} /> Our anthem</p>
        <h2 className="font-display text-3xl sm:text-4xl font-semibold mb-6">{s.anthem_title || "The song of our mission"}</h2>
        {isVideo ? (
          <video src={url} controls playsInline className="w-full rounded-lg max-h-[70vh] bg-black" data-testid="anthem-video" />
        ) : (
          <audio src={url} controls className="w-full" data-testid="anthem-audio" />
        )}
      </div>
    </section>
  );
}
